module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-800.7fb48daa.svg";